module.exports = __webpack_public_path__ + "img/DK25992180.62454b52.png";